import React from "react";
import { ZapIcon, InfinityIcon, ShieldCheckIcon, CreditCardIcon } from "lucide-react";
import { CTAButton } from "./CTAButton";
import { images } from "../data/landing";
const assurances = [{
  icon: ZapIcon,
  label: "Instant digital access"
}, {
  icon: CreditCardIcon,
  label: "One-time payment"
}, {
  icon: InfinityIcon,
  label: "Lifetime access"
}, {
  icon: ShieldCheckIcon,
  label: "7-day guarantee"
}];
export function Hero() {
  return <header className="w-full bg-ink" data-id="element-167" data-mp="128pg780q2n1x">
      <div className="flex items-center justify-center gap-2 bg-alert px-4 py-2.5 text-center text-xs font-extrabold uppercase tracking-wider text-white sm:text-sm" data-id="element-168" data-mp="x9upzl0fdw7s">
        <span className="h-2 w-2 shrink-0 rounded-full bg-white animate-soft-pulse" aria-hidden="true" data-id="element-169" data-mp="sddzik5r75rj" />
        The special offer is available now
      </div>

      <div className="mx-auto grid max-w-6xl items-center gap-8 px-5 pb-16 pt-10 sm:px-8 md:pt-16 lg:grid-cols-[1.05fr_1fr] lg:gap-12 lg:pb-24" data-id="element-170" data-mp="3d2ldtocrhr6i">
        <div className="text-center lg:text-left" data-id="element-171" data-mp="384s5oprwen3l">
          <p className="font-serif text-2xl font-bold tracking-wide text-gold sm:text-3xl" data-id="element-172" data-mp="3j9k7h1pgwzbd">
            HOF CLINICAL BLUEPRINT™
          </p>
          <p className="mt-2 text-sm font-medium text-muted sm:text-base" data-id="element-173" data-mp="3o59e1ozwngh6">
            A Structured Clinical Safety System for Facial Aesthetic Practitioners
          </p>

          <h1 className="mt-6 font-serif text-[2.35rem] font-extrabold leading-[1.08] text-cream sm:text-6xl" data-id="element-174" data-mp="3e7uxlpdzerov">
            Build a More Structured Approach to Facial Aesthetic Safety in{" "}
            <span className="text-gold" data-id="element-175" data-mp="359j6znd47twf">30 Minutes a Day</span>
          </h1>

          <p className="mt-6 text-lg font-semibold leading-snug text-cream sm:text-xl" data-id="element-176" data-mp="2qkmv1f7xtwqj">
            Stop relying on scattered notes and disconnected resources when preparing for complex aesthetic cases.
          </p>

          {/* Mockup on mobile appears right after the promise */}
          <img src={images.mockup} alt="HOF Clinical Blueprint six volumes, five bonuses and digital devices" className="mx-auto mt-8 w-full max-w-lg lg:hidden" data-id="element-177" data-mp="2lla4okhuy7j7" />

          <p className="mt-8 text-base leading-relaxed text-muted sm:text-lg" data-id="element-178" data-mp="nb1jf112jluu">
            I created HOF CLINICAL BLUEPRINT™ to help facial aesthetic practitioners organize their clinical safety
            knowledge into a structured, practical system they can review before appointments, use to support clinical
            reasoning, and revisit when evaluating unexpected situations.
          </p>
          <p className="mt-4 text-base leading-relaxed text-muted sm:text-lg" data-id="element-179" data-mp="161j88uis5xax">
            Inside, you will receive <strong className="text-cream" data-id="element-180" data-mp="111om149y9vw7">6 comprehensive volumes</strong>,{" "}
            <strong className="text-cream" data-id="element-181" data-mp="x1nvil9ktu8s">5 specialized professional resources</strong>, and a collection of clinical
            checklists, assessment frameworks, and educational case studies designed for facial aesthetic practice.
          </p>

          <div className="mt-8 rounded-2xl bg-panel p-5 ring-1 ring-gold/30 sm:p-6" data-id="element-182" data-mp="3hq266xcxa69u">
            <p className="text-sm font-extrabold uppercase tracking-[0.18em] text-gold" data-id="element-183" data-mp="1xavxukzeea7s">
              6 Volumes + 5 Exclusive Bonuses
            </p>
            <p className="mt-2 font-serif text-4xl font-extrabold text-cream sm:text-5xl" data-id="element-184" data-mp="26a98hgz9d4u3">
              Today: just <span className="text-gold" data-id="element-185" data-mp="2b0fz1mdbyzez">$27 USD</span>
            </p>
            <div className="mt-5 flex justify-center lg:justify-start" data-id="element-186" data-mp="2b2k9yo9ncyor">
              <CTAButton id="first-cta" size="xl" label="Get the HOF Clinical Blueprint™" data-id="element-187" data-mp="2fzanb3u2hg6h" />
            </div>
            <ul className="mt-5 grid grid-cols-2 gap-x-3 gap-y-2.5 text-left" data-id="element-188" data-mp="2kx2h63e9vcdb">
              {assurances.map(({
              icon: Icon,
              label
            }) => <li key={label} className="flex items-center gap-2 text-[13px] font-medium text-cream sm:text-sm" data-id="element-189" data-mp="2tzbokke8upmh">
                  <Icon className="h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-190" data-mp="un9ajpoe2ng7" />
                  {label}
                </li>)}
            </ul>
          </div>

          <p className="mt-5 text-xs leading-relaxed text-muted/80" data-id="element-191" data-mp="4b461q1btyhv">
            Educational reference materials for qualified professionals. This system does not replace clinical training,
            individualized assessment, or emergency protocols.
          </p>
        </div>

        <img src={images.mockup} alt="HOF Clinical Blueprint six volumes, five bonuses and digital devices" className="hidden w-full lg:block" data-id="element-192" data-mp="e77ibopw7dij" />
      </div>
    </header>;
}